import { Component } from '@angular/core';
import { PipeServiceImpl } from 'pipe-service/pipe-service-impl';

@Component({
    templateUrl: './boud.component.html',
    styleUrls: ['./boud.component.scss'],
})
export class BoudComponent { 

    //Nombre de la confituración del visor en el json
    viewerConfigId: string = "deusto-boud-viewer";

    constructor(private pipeService: PipeServiceImpl) {}

    ngOnDestroy(): void {
        // Necesitamos limpiar los maps por si han actualizado algún valor
        this.pipeService.refreshMaps();
    }
    
}